import { Injectable } from '@angular/core';
import { MtxApiService } from 'libs/modules/tunnelsante/services/api/mtx-api.service';
import { CookieService } from 'ngx-cookie';
import { finalize } from 'rxjs/operators';
import { BaseAuthorizationGuard } from '../../../libs/modules/tunnelsante/guards/base-authorization.guard';
import { LoggerService } from '../../../libs/modules/tunnelsante/services/logger/logger.service';
import { AuthenticationModels } from '../../../models/authentication.models';
import { CommonModels } from '../../../models/common.models';
import { AfiAuthenticationService } from '../services/tunnel-authentication.service';
import { TunnelNavigationService } from '../services/tunnel-navigation.service';

@Injectable({ providedIn: 'root' })
export class TunnelAuthorizationGuard extends BaseAuthorizationGuard {
  protected expectedAccountKind: CommonModels.AccountKind =
    CommonModels.AccountKind.Broker;

  constructor(
    private tunnelAuthService: AfiAuthenticationService,
    private tunnelNavService: TunnelNavigationService,
    loggerService: LoggerService,
    override mtxApiService: MtxApiService,
    override cookieService: CookieService,
  ) {
    super(tunnelAuthService, loggerService, mtxApiService, cookieService);
  }

  protected navigateOnError(account?: AuthenticationModels.Account) {
    // Full access
    let logger = this.loggerService.getLogger('Authorization');

    if (account) {
      if (account.hasRight(AuthenticationModels.RightEnum.AccessBrokerApp)) {
        this.tunnelNavService.goToDashboard();
      } else if (
        account.hasRight(AuthenticationModels.RightEnum.SignAgencySubscription)
      ) {
        this.tunnelNavService.goToSignature();
      } else if (
        account.hasRight(AuthenticationModels.RightEnum.ReadAgencySubscription)
      ) {
        this.tunnelNavService.goToSubscription();
      } else {
        logger.log(`Missing Right`);
      }
    } else {
      this.tunnelAuthService
        .logoff()
        .pipe(
          finalize(() => {
            this.tunnelAuthService.forceGetAccessToken().subscribe((resp) => {
              this.tunnelAuthService.impersonate(resp);

              let url: any = sessionStorage.getItem('urlNext');

              if (this.tunnelNavService.isUrlParamOrigin(url)) {
                let urlRedirect = this.tunnelNavService.getUrlParamOrigin(url);
                this.tunnelNavService.goToUrlParamOrigin(urlRedirect);
              }

              if (url.includes('souscription-en-ligne')) {
                this.tunnelNavService.goToSouscriptionEnligne();
              } else if (url.includes('param=') || url.includes('?')) {
                this.tunnelNavService.goToTunnelWithParams();
              } else this.tunnelNavService.goToCarInsuranceQuotation();
            });
          }),
        )
        .subscribe();
    }
  }
}
